import React from 'react';

export function PlayerStrip({ players, activePlayerId, viewerId, onSelect, selectedId }) {
  return (
    <nav className="player-strip" aria-label="Spieler">
      {players.map((player) => (
        <button
          type="button"
          key={player.id}
          className={`player-chip ${player.id === activePlayerId ? 'is-active' : ''} ${player.id === selectedId ? 'is-selected' : ''}`}
          onClick={() => onSelect(player.id)}
        >
          <span className="player-chip__avatar">{player.isBot ? '🤖' : player.name.slice(0, 1).toUpperCase()}</span>
          <span><strong>{player.name}{player.id === viewerId ? ' (du)' : ''}</strong><small>{player.childMode ? '🧒 Hilfe aktiv' : `${player.score.total} Punkte`}</small></span>
          {player.id === activePlayerId && <i title="am Zug">●</i>}
        </button>
      ))}
    </nav>
  );
}
